module.exports = __webpack_public_path__ + "img/Networking_Environment.48c3a6f5.png";